var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166,
    height: 96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "A",
    cx: 38,
    cy: 47,
    r: 13
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.8%",
    y: "-5.8%",
    width: "111.5%",
    height: "111.5%",
    id: "B"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.43322577 0 0 0 0 0.431549992 0 0 0 0 0.431549992 0 0 0 1 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(58 17.938)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.234 21.787l-5.956 5.617-5.53-11.3 2.856-6.497c.722-1.296 1.903-1.313 2.624 0l6.005 12.18z",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f57f17",
    d: "M22.28 27.4L0 48.388l16.75-32.284z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.765 13.197c1.067-1.03 2.166-.682 2.443.78L43 48.105l-19.21 11.68c-.674.38-2.46.53-2.46.53s-1.625-.2-2.248-.548L0 48.388l34.765-35.192z",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 16.104L0 48.388 7.465 1.2c.28-1.462 1.1-1.61 1.837-.315l7.448 15.22z",
    fill: "#ffa000"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#B)",
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#777",
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.113 42.584L37.6 40l6.395 2.4v3.68l-6.395-2.4-6.476 2.584zm.08 5.336l6.395-2.4 6.395 2.4v3.68l-6.395-2.4-6.395 2.4zm6.396 2.86l1.827-.1 3.197 1.38L37.6 54z",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirestore);
export default __webpack_public_path__ + "static/media/Firestore.72d7cdd15a3844ab51e80e831825c5df.svg";
export { ForwardRef as ReactComponent };